import type { CSSProperties } from 'react';
import styled from 'styled-components';

import {
  WINTER_GOLDEN_STYLE,
  WINTER_STYLE,
} from '@sorare/core/src/components/card/ScarcityBackground';

import defaultBackground from './assets/default.webp';
import goldenBackground from './assets/golden.webp';

const Root = styled.div`
  position: absolute;
  inset: 0;
  background: var(--bg-url) no-repeat center center;
  background-size: cover;
  z-index: 0;
`;

type Props = {
  golden?: boolean;
  slug?: string;
};
export const Background = ({ golden, slug = '' }: Props) => {
  const isWinter = /wi?nte?r/i.test(slug);
  return (
    <Root
      style={
        {
          background:
            // eslint-disable-next-line no-nested-ternary
            isWinter
              ? golden
                ? WINTER_GOLDEN_STYLE
                : WINTER_STYLE
              : `url(${golden ? goldenBackground : defaultBackground}) no-repeat center center / cover`,
          backgroundBlendMode:
            // eslint-disable-next-line no-nested-ternary
            isWinter
              ? golden
                ? 'color, color-dodge, color-dodge, normal'
                : 'color-dodge,color-dodge,normal'
              : 'reset',
        } as CSSProperties
      }
    />
  );
};
